


//main bg is responsible for the navbar 
export const main_bg = '#222f3e'


//active orange color for drawer 
export const act_col = '#007eb9'